import { BillGsmDetailsPaginatorInterface } from '../../../bills/models/bill-gsm-details.paginator.interface';

export interface BillGsmDetailsInterfaceState {
  list: BillGsmDetailsPaginatorInterface;
}

export const initialBillGsmDetailsState: BillGsmDetailsInterfaceState = {
  list: null
};
